import { Avatar, Box, Grid, IconButton, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import React, { useState } from 'react';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import moment from 'moment-timezone';
import { makeStyles } from 'tss-react/mui';
import { ComplianceStatusProgressNotesDetails } from 'app/models/Placement/PlacementDetails';
import { placementDetailsAction } from 'store/redux-store/placement-details/slice';
import { useDispatch } from 'react-redux';

export type ComplianceStatusProgressNotesProps = {
    cspNotes: Array<ComplianceStatusProgressNotesDetails>;
    fullScreen: boolean;
}

const useStyles = makeStyles<{ fullScreen: boolean }>()((theme, { fullScreen }) => ({
    container: {
        backgroundColor: theme.palette.system.lightGray,
        overflow: 'hidden',
    },
    noteDetails: {
        marginTop: '12px',
        overflowY: 'auto',
        display: 'flex',
    },
    avatarContainer: {
        marginRight: '2px',
        display: 'flex',
        justifyContent: 'center',
        maxWidth: '32px',
    },
    avatar: {
        backgroundColor: "#d0cce2",
        color: theme.palette.framework.system.violet,
        height: '30px',
        width: '30px',
        fontSize: '12px',
    },
    noteContent: {
        flex: '1',
        width: fullScreen ? '98vw' : '500px', // default width
        paddingLeft: '12px',
        paddingBottom: '12px',
        borderBottom: `2px solid ${theme.palette.system.lightGrey2}`,
    },
    userDetailsContainer: {
        display: 'flex',
    },
    userNameText: {
        fontSize: "12px !important",
        color: theme.palette.framework.system.coolGray,
        paddingRight: '4px',
    },
    lastUpdatedText: {
        fontSize: "12px !important",
        color: theme.palette.framework.system.coolGray,
    },
}));



const ComplianceStatusProgressNotes = ({ cspNotes, fullScreen, userInfo }) => {
    const { classes } = useStyles({ fullScreen });
    return (
        <>
            <Grid container className={classes.container}>
                <Typography>{`Recents (${(cspNotes ?? []).length})`}</Typography>
                <Grid container className={classes.container}>
                    {(cspNotes ?? []).length > 0 &&
                        cspNotes.map((cspNote, index) => {
                            const userName = cspNote.userName.split(' ');
                            const eod = moment.tz(cspNote.lastUpdatedDate, 'America/Los_Angeles').endOf('day')
                            const isEditEnabled = userName[0]?.toLowerCase() === userInfo.firstName?.toLowerCase()
                                && userName[1]?.toLowerCase() === userInfo.lastName?.toLowerCase()
                                && eod.diff(moment.tz(moment().utc(), 'America/Los_Angeles')) > 0
                            return (
                                <ComplianceStatusNotesDetails
                                    cspNote={cspNote}
                                    key={index}
                                    userName={userName}
                                    fullScreen={fullScreen}
                                    isEditEnabled={isEditEnabled}
                                />
                            );
                        })}
                </Grid>
            </Grid>
        </>
    );
};
export default ComplianceStatusProgressNotes

const ComplianceStatusNotesDetails = ({ cspNote, key, userName, fullScreen, isEditEnabled }) => {
    const { classes } = useStyles({ fullScreen });
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [openCSPEdit, setOpenCSPEdit] = useState<boolean>(false);
    const dispatch = useDispatch();

    return (
        <Box key={key} className={classes.noteDetails}>
            <Box className={classes.avatarContainer}>
                <Avatar className={classes.avatar}>
                    {`${userName[0].charAt(0) + userName[1].charAt(0)}`}
                </Avatar>
            </Box>
            <Box className={classes.noteContent}>
                <Typography>{cspNote.notes}</Typography>
                <Box className={classes.userDetailsContainer}>
                    <Typography className={classes.userNameText}>{cspNote.userName}</Typography>
                    <Typography className={classes.lastUpdatedText}>
                        {userName[1] === "AMIE" ? moment(cspNote.lastUpdatedDate).format('MM/DD/YYYY')
                            : moment(cspNote.lastUpdatedDate).format('MM/DD/YYYY hh:mm A')}
                    </Typography>
                </Box>
            </Box>
            <Box >
                <IconButton
                    onClick={(event: React.MouseEvent<HTMLElement>) => {
                        event.stopPropagation();
                        setAnchorEl(event.currentTarget);
                        setOpenCSPEdit(true);
                    }}
                >
                    <MoreVertOutlinedIcon fontSize="small" />
                </IconButton>
            </Box>
            <Menu
                data-testid="reqSet-kebab-menu"
                anchorEl={anchorEl}
                keepMounted
                open={openCSPEdit}
                onClose={() => {
                    setOpenCSPEdit(false);
                }}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <MenuItem
                    onClick={() => {
                        setOpenCSPEdit(false);
                        dispatch(placementDetailsAction.editComplianceStatusNotes(cspNote));
                        dispatch(placementDetailsAction.setEditComplianceStatusNotes(true));
                        dispatch(placementDetailsAction.toggleComplianceStatusNotesDrawerNoteTextboxExpanded(true));
                    }}
                    disabled={!isEditEnabled}
                >
                    <ListItemText disabled={!isEditEnabled}>{"Edit"}</ListItemText>
                </MenuItem>
            </Menu>
        </Box>
    );
};